// extracted by mini-css-extract-plugin
export var copyableField = "_o2-4";
export var customerBadge = "_o2-0";
export var customerInfoTitle = "_o2-2";
export var details = "_o2-1";
export var dropdownContainer = "_o2-5";
export var dropdownImage = "_o2-6";
export var editAssigneeForm = "_o2-a";
export var editButton = "_o2-3";
export var email = "_o2-7";
export var hidden = "_o2-d";
export var input = "_o2-8";
export var saveButton = "_o2-b";
export var shopifyIcon = "_o2-c";
export var suggestionBadge = "_o2-e";
export var suggestionText = "_o2-f";
export var username = "_o2-9";